'use client';
import React from 'react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { FaArrowRight, FaArrowLeft, FaStar } from 'react-icons/fa6';

import Image from 'next/image';
import Link from 'next/link';
import { useAppDispatch } from '@/lib/redux/hooks';
import { addItem } from '@/lib/redux/features/cart';
import dynamic from 'next/dynamic';
const FlashSalesCountdown = dynamic(() => import('./FlashSalesCountdown'), {
  ssr: false, // Ensure it's only rendered on the client
});
import products from '../../../../../public/json/popular-product.json';
const FlashSales = () => {
  const despatch: any = useAppDispatch();

  const handleClick = (product: any) => {
    despatch(addItem(product));
  };
  return (
    <section className="product padding-top padding-bottom section-bg">
      <div className="container">
        <div className="section-header">
          <FlashSalesCountdown
            date={new Date(
              new Date().setMonth(new Date().getMonth() + 1)
            ).toISOString()}
          />

          <div className="section-header__action order-sm-2">
            <div className="swiper-nav swiper-nav--style1">
              <button
                aria-label="Previous slide"
                className="swiper-nav__btn product__slider-prev"
              >
                <FaArrowLeft />
              </button>
              <button
                aria-label="Previous slide"
                className="swiper-nav__btn product__slider-next active"
              >
                <FaArrowRight />
              </button>
            </div>
          </div>
        </div>
        <div
          className="product__wrapper"
          data-aos="fade-up"
          data-aos-duration={1000}
        >
          <div className="product__slider">
            <Swiper
              modules={[Navigation]}
              spaceBetween={20}
              slidesPerView={3}
              breakpoints={{
                320: { slidesPerView: 1 },
                425: { slidesPerView: 1 },
                768: { slidesPerView: 3 },
                1024: { slidesPerView: 3 },
              }}
              navigation={{
                nextEl: '.product__slider-prev',
                prevEl: '.product__slider-next',
              }}
            >
              {products?.length > 0 &&
                products.slice(0, 4).map((product: any, i: number) => (
                  <SwiperSlide key={i}>
                    <div className="product__item product__item--style1">
                      <div className="product__item-inner">
                        {product.discount && (
                          <div className="product__item-badge">
                            -{product.discount}%
                          </div>
                        )}
                        <div className="product__item-thumb">
                          <Image
                            width={374}
                            height={232}
                            src={product.imgSrc2}
                            alt={product.title}
                          />
                        </div>
                        <div className="product__item-content">
                          <h4>
                            <Link href="/product-details">
                              {product.title2}
                            </Link>
                          </h4>
                          <div className="product__item-rating">
                            <FaStar /> {product.rating}{' '}
                            <span>({product.reviews} Reviews)</span>
                          </div>
                          <div className="product__item-footer">
                            <div className="product__item-price">
                              <h4>${Number(product.price).toFixed(2)} /</h4>
                              <span>
                                <del>${Number(product.price).toFixed(2)}</del>
                              </span>
                            </div>
                            <div className="product__item-action">
                              <span
                                onClick={() => handleClick(product)}
                                className="trk-btn trk-btn--outline"
                              >
                                Add to cart
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
            </Swiper>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlashSales;
